import { gen } from '../../views/utils'
import { name } from '../../views/utils/filters'

export default {
  auto: '*',
  store: {
    getters: {
      genContact: gen(() => ({
        groupId: null,
        clientId: null,
        name: null,
        address: null,
        phone: null,
        email: null,
      })),

      contactFromClient: (_, { genContact }) => client => genContact({
        groupId: client.groupId,
        clientId: client.id,
        name: name(client),
        phone: client.phone,
      }),
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/contacts.js